<template>
    <div>
        <CommentPanel :commentData="commentData" :appId="appId" @openModal="openCommentsModal" :inPanel="true"></CommentPanel>
        <AllCommentsModal :commentData="commentData" :appId="appId" v-show="showComments" @closeModal="closeCommentsModal"></AllCommentsModal>
    </div>
</template>

<script>
import CommentPanel from "./CommentPanel";
import AllCommentsModal from "./AllCommentsModal";
export default {
    props: ["appId", "commentData"],
    components: { CommentPanel, AllCommentsModal },
    name: "CommentBloc",
    data() {
        return {
            showComments: false
        };
    },
    methods: {
        closeCommentsModal() {
            this.showComments = false;
        },
        openCommentsModal() {
            this.showComments = true;
        }
    }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// CommentBloc.vue?e31f7dfa